export { sendAcceleraEvent } from './lib';
import { serpPageOpened } from './search-page';
import { bookingSucceeded, bookingFailed } from './products-page';

export const acceleraEventsLib = {
  serpPageOpened,
  bookingSucceeded,
  bookingFailed,
};
